'use client'

import { Textarea } from '@/components/ui/textarea'
import { FieldShell, premiumTextareaClass } from './field-shell'
import type { AnswerableFieldProps } from './types'

export function LongTextField({ props, mode, value, onChange, error }: AnswerableFieldProps<'LongText', string>) {
  const isPreview = mode === 'preview'
  return (
    <FieldShell
      mode={mode}
      htmlFor={props.id}
      label={props.label}
      required={props.required}
      helpText={props.helpText}
      error={error}
      conditional={Boolean(props.showIf)}
    >
      <Textarea
        id={props.id}
        rows={3}
        className={premiumTextareaClass}
        placeholder={props.placeholder}
        maxLength={props.maxLength}
        readOnly={isPreview}
        value={isPreview ? '' : typeof value === 'string' ? value : ''}
        onChange={isPreview ? undefined : e => onChange?.(e.target.value)}
      />
    </FieldShell>
  )
}
